import {InputDropdownProps} from "app/Interface/Component/FormDropdown"
import EventService from "app/Service/EventService"
import cls from "classnames"
import {StickyEvent} from "const/StickyEvent"
import React, {MouseEvent, useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import {usePopper} from "react-popper"

function InputDropdownSticky({loading, options, variant, onChange, doPublishEvent, placement}: InputDropdownProps) {

  const {t} = useTranslation('ComponentsForm.InputDropdown')

  const {publishEvent} = EventService('InputDropdown')

  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null)
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null)
  const {styles, attributes} = usePopper(referenceElement, popperElement, {
    strategy: 'fixed',
    placement: placement ?? 'bottom-end',
  })

  const [buttonText, setButtonText] = useState<string>()
  const [buttonClass, setButtonClass] = useState<string>()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if ((undefined === loading || loading) && options.length < 1)
      setButtonText(t('title.loading'))
    else {
      if (options.length < 1)
        setButtonText(t('title.noOptions'))
      else {
        const option = options.find(o => o.active)
        if (option)
          setButtonText(option.name)
        else
          setButtonText(t('title.select'))
      }
    }
  }, [loading, options])

  useEffect(() => {
    if (open)
      window.addEventListener('mousedown', handleWindowClick)
    else
      window.removeEventListener('mousedown', handleWindowClick)

    return () => {
      window.removeEventListener('mousedown', handleWindowClick)
    }
  }, [open, popperElement])

  useEffect(() => {
    setButtonClass(cls(
      `dropdown-toggle btn`,
      {
        'btn-secondary': !(!!variant),
        'hide-carrot': loading || options.length < 1
      },
      variant && `btn-${variant}`)
    )
  }, [variant, options])

  function handleWindowClick(event: Event) {
    if (!popperElement) return

    const target = event.target as Node
    if (popperElement.contains(target) || target === referenceElement)
      return

    toggleDropdownOpen()
  }

  function mainButtonClick(e: MouseEvent) {
    e.preventDefault()
    if (options.length > 0) {
      toggleDropdownOpen()
    }
  }

  function toggleDropdownOpen() {
    setOpen(v => !v)
    if (undefined === doPublishEvent || doPublishEvent)
      publishEvent<'dropdownOpen'>(StickyEvent.dropdownOpen, {isOpen: !open})
  }

  function renderDropdown() {
    return (
      <div
        ref={ref => setPopperElement(ref)}
        style={styles.popper}
        {...attributes.popper}
        className={`dropdown-container`}
      >
        {options.map(o => {
          return (
            <div
              key={o.id}
              className={`dropdown-option`}
              onClick={() => {
                toggleDropdownOpen()
                onChange(o)
              }}
            >{o.name}</div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <button
        type={'button'}
        className={buttonClass}
        onClick={e => mainButtonClick(e)}
        ref={ref => setReferenceElement(ref)}
        aria-expanded={open}
      >
        {buttonText}
      </button>
      {open && (
        renderDropdown()
      )}
    </>
  )
}

export default InputDropdownSticky
